


































import _ from 'lodash';
import { PageModeMixin } from '@/main/mixins/pageMode';
import mixins from 'vue-typed-mixins';

import { apiProvider } from '../api';
import { editMutations } from '../store/types';


export default mixins(PageModeMixin).extend({
	name: 'AresDialog',
	props: {
		visible: { type: Boolean, required: true },
		filter: { type: Object, required: true },
		storeUri: { type: String, required: true },
	},
	data() {
		return {
			tabItems: {
				rejstrikKzv: { id: 'rejstrikKzv', labelKey: 'Rejstrik' },
				rejstrik: { id: 'rejstrik', labelKey: 'RejstrikAll' },
			},
			activeTab: [],
			loading: true,
			table: [],
			tablePolozky: [] as { name: string, rejstrik: any }[],
			tableKey: '0',
		};
	},
	watch: {
		visible(newVal) {
			if (newVal) {
				this.table = [];
				this.tablePolozky = [];
				this.getAresData();
			}
		},
	},
	methods: {
		async getAresData() {
			let response = null;
			try {
				response = (await apiProvider.getAresData(this.filter)).data;
			} catch {
				this.$emit('cancel-clicked');
			}
			if (!response) {
				this.$emit('cancel-clicked');
				return;
			}
			this.table = response.MergePolozky;
			this.tablePolozky = [];
			const polozky = response.Polozky;
			Object.keys(polozky).forEach((key) => {
				this.tablePolozky.push({ name: key, rejstrik: polozky[key] });
			});
			this.tableKey += 1;
			this.loading = false;
		},
		cellValueRenderer(val: any) {
			let value = val;
			if (typeof val === 'boolean') {
				value = val ? this.Localize('Ano') : this.Localize('Ne');
			} else if (Array.isArray(val)) {
				if (val.length) {
					value = val.join();
				} else {
					value = '';
				}
			}
			return value;
		},
		getLocalized(text: string) {
			return this.Localize(_.snakeCase(text).toUpperCase());
		},
		async updateKVZ() {
			const updatedData = this.table.map((row: { Name: string, Rejstrik: string, Kartoteka: string, DataType: number }) => (
				{ name: row.Name, value: row.Rejstrik, dataType: row.DataType }));
			this.$store.commit(`${this.storeUri}/${editMutations.SET_ARES_DATA}`, updatedData);
			this.$emit('cancel-clicked');
		},
	},
});
